module.exports = __webpack_public_path__ + "img/w61b.47788dc5.jpg";